import { http } from '../../config/HttpMethod';
import { GetEquipmentCatalogPayload, uploadEquipmentPayload } from '../../store/model/equipment-catalog/catalog';
import { ESP_ENDPOINTS } from '../calculations/endpoints';

export const getEquipmentCatalog = async (payload: GetEquipmentCatalogPayload) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.GET_CATALOG_DATA}`, payload);
        return response.data;
    } catch (error) {
        return error;
    }
};

export const exportEquipmentCatalog = async (payload: GetEquipmentCatalogPayload) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.GET_CATALOG_EXPORT_EXCEL}`, payload, {
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json' }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export const validateUploadEquipment = async (payload: any) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.VALIDATE_CATALOG_EXCEL}`, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    } catch (error: any) {
        return error?.response?.data;
    }
};


export const updateExportEquipmentCatalog = async (payload: any) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.CATALOG_BULK_IMPORT}`, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error: any) {
        return error?.response?.data;
    }
};

export const getAuditLog = async (payload: GetEquipmentCatalogPayload) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.CATALOG_AUDIT_DATA}`, payload);
        return response.data;
    } catch (error) {
        return error;
    }
};
